import Immutable from 'immutable';
import { createReducer } from '../utils';
import * as types from '../actionTypes/caseLookupActionTypes'

export const initialFilters = {
  // form
  case_no: '',
  party_title: '',
  search_type: 'party_title',

  // sorting
  sort: 'asc',
  order: 'Case Title',

  // queries
  case_type: 'Bankruptcy',
  filed_from: null,
  filed_to: null,

  // facets
  year: null,
  chapter: null,
  court_name: null,

  // region dropdown
  region_name: null,

  page: 1,
};

const initialParams = {
  isReady: false,
  isError: false,
  contents: [],
  facets: {
    year: {},
    court_name: {},
    case_type: {},
    chapter: {},
  },
  pages: {
    pageindex: 1,
    pagesize: 1,
    totalitems: 1,
  },
};

const initialStateValue = {
  ...initialParams,
  filters: initialFilters,
};

export const initialState = Immutable.fromJS(initialStateValue);

export default createReducer(initialState, {
  [types.CLEAR_ALL_FILTERS_OF_CASE_LOOKUP]: (state) => {
    const oldFilters = state.get('filters');
    const newFilters = oldFilters.mergeDeep({
      year: initialFilters.year,
      chapter: initialFilters.chapter,
      court_name: initialFilters.court_name,
      region_name: null,
      filed_from: (oldFilters.get('year')) ? initialFilters.filed_from : oldFilters.get('filed_from'),
      filed_to: (oldFilters.get('year')) ? initialFilters.filed_to : oldFilters.get('filed_to'),
    });

    return state.mergeDeep({ filters: newFilters });
  },
  [types.REQUEST_CASE_DATA_OF_CASE_LOOKUP]: state =>
    state
      .mergeDeep(initialParams)
      .set('contents', []),
  [types.RECEIVE_CASE_DATA_OF_CASE_LOOKUP]: (state, action) => {
    const { facets = initialParams.facets } = action;
    const { pages = initialParams.pages } = action;

    // :(
    const nextPages = {
      pageindex: parseInt(pages.pageindex, 10),
      pagesize: parseInt(pages.pagesize, 10),
      totalitems: parseInt(pages.totalitems, 10),
    };

    return state
      .set('isReady', true)
      .set('contents', action.contents)
      .set('contents', action.contents)
      .set('pages', Immutable.fromJS(nextPages))
      .set('facets', Immutable.fromJS(facets));
  },
  // On error, reset everything but the filters
  [types.RECEIVE_CASE_LOOKUP_ERROR]: state => state
    .set('isError', true)
    .set('isReady', true)
  ,
  [types.UPDATE_FILTERS_OF_CASE_DATA_OF_CASE_LOOKUP]: (state, action) => state
    .mergeDeep({ filters: action.filter }),
});



// WEBPACK FOOTER //
// ./src/redux/reducers/caseLookupSearchReducer.js